export default {
    methods:{
        getCityForZipCode(zipCode) {
            return new Promise((resolve, reject) => {
                let axiosInstance = axios.create();
                axiosInstance.defaults.headers.common = {};

                axiosInstance.get(`https://dawa.aws.dk/postnumre?nr=${zipCode}`).then((response) => {
                    if (response.data.length > 0) {
                        resolve(response.data[0].navn);
                    }else{
                        reject(response.data);
                    }
                }).catch((response) => {
                    reject(response);
                });
            });
        },
    }
}